module.exports = "https://static-production.npmjs.com/f1786e9b7cba9753ca7b9c40e8b98f67.png";